import React from 'react';
import OrdersPage from './OrdersPage';

const OrdersManaPoolPage: React.FC = () => {
  return (
    <OrdersPage
      fixedSource="manapool"
      initialStatusGroup="completed"
      title="Orders"
      subtitle="Unified order view filtered to Manapool"
      cardTitle="Manapool Orders"
    />
  );
};

export default OrdersManaPoolPage;
